import { render, staticRenderFns } from "./SongrequestSettings.vue?vue&type=template&id=2c52e3af&"
import script from "./SongrequestSettings.vue?vue&type=script&lang=ts&"
export * from "./SongrequestSettings.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports